import { getFilteredClasses } from '../../../utils';
import styles from './styles.module.scss';
import { IButton } from '../types';

const buildButtonClass = ({ className, size, variant = 'primary', weight }: IButton) => {
  const sizeClass = size && `btn-${size}`;
  const variantClass = variant && `btn-${variant}`;
  const weightClass = weight && `font-weight-${weight}`;
  const isLink = variant === 'link' && styles.buttonLink;
  const filteredClasses = getFilteredClasses([variantClass, sizeClass, weightClass, className, isLink]);
  return `btn ${filteredClasses}`.trim();
};

export { buildButtonClass };
